// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3oNGA","footer":"ModalFilter_footer__3CpUa"};